module.exports = __webpack_public_path__ + "img/Social_text01_social.1fe92bad.png";